import { render, staticRenderFns } from "./ReportCommentAlertList.vue?vue&type=template&id=65ff0726&"
import script from "./ReportCommentAlertList.vue?vue&type=script&lang=js&"
export * from "./ReportCommentAlertList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports